import React from 'react';
import { CustomDialog } from '../CustomDialog';
import { useEvent } from '../../hooks/useEvent';

interface DialogRevertEventProps {
  eventId: number; // event id to revert
  onSuccess: () => void;  // Callback to refresh events list after reverting
  onCancel: () => void; // Callback to close the dialog
}

export const DialogRevertEvent: React.FC<DialogRevertEventProps> = ({ eventId, onSuccess, onCancel }) => {
  const { handleRevertEvent, updating } = useEvent();

  const handleRevert = async () => {
    const success = await handleRevertEvent(eventId);
    if (success) {
      onSuccess();
    }
    onCancel();
  };

  return (
    <CustomDialog
      title="Are you sure you want to revert this event?"
      description='By reverting, your event will be released from the ETA TA Event Calendar and you will be required to resubmit your event for approval.'
      primaryButtonText="Yes, revert this event"
      secondaryButtonText="Cancel"
      open={true}
      onClose={onCancel}
      onPrimaryButtonClick={handleRevert}
      onSecondaryButtonClick={onCancel}
      disablePrimaryButton={updating}
    />
  );
}; 